import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './drag-popup.scss';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import Layout from '../../helpers/Layout';
import { REDUCER_NAME, setDragPopup } from '../reducer';
import {
  changeCountPopout,
  REDUCER_NAME as COMMON_REDUCER_NAME,
} from '../../app/commonReducer';
import { Translate } from 'react-redux-i18n';

class DragPopup extends PureComponent {
  rootRef = React.createRef();
  dragSource = null;

  componentDidMount() {
    Layout.layout.on('componentCreated', this.onComponentCreated);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { dragPopup } = this.props;
    const listComponentTitle = I18n.t('common.listComponent');
    if (dragPopup !== prevProps.dragPopup && dragPopup.isShow) {
      if (this.dragSource) {
        this.dragSource._dragListener.destroy();
      }
      this.dragSource = Layout.drag(
        this.rootRef.current,
        {
          title: listComponentTitle[dragPopup.componentName],
          name: dragPopup.componentName,
          tooltip: listComponentTitle[dragPopup.componentName],
        },
        { dragCode: this.getCode(), ...(dragPopup.props || {}) },
      );
    }
    this.keyUpListener(prevProps);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp);
    if (this.dragSource) {
      this.dragSource._dragListener.destroy();
    }
  }

  keyUpListener = prevProps => {
    const { dragPopup } = this.props;
    const { dragPopup: prevDragPopup } = prevProps;
    if (dragPopup.isShow && !prevDragPopup.isShow) {
      window.addEventListener('keyup', this.onKeyUp);
    }

    if (!dragPopup.isShow && prevDragPopup.isShow) {
      window.removeEventListener('keyup', this.onKeyUp);
    }
  };

  onKeyUp = e => {
    const { setDragPopup } = this.props;
    if (e.keyCode === 27) {
      setDragPopup({
        isShow: false,
      });
      window.removeEventListener('keyup', this.onKeyUp);
    }
  };

  getCode = () => {
    const {
      dragPopup,
      listOrganizationByOrganCode,
      listCoveredWarrantCode,
      listDerivativeByDerivativeCode,
    } = this.props;
    const obj = {
      ...listOrganizationByOrganCode,
      ...listCoveredWarrantCode,
      ...listDerivativeByDerivativeCode,
    };

    const code = obj[dragPopup.organCode];
    if (!code) {
      return false;
    }
    return code;
  };

  onComponentCreated = () => {
    const { setDragPopup } = this.props;
    setDragPopup({
      isShow: false,
    });
  };

  onClick = e => {
    const { setDragPopup } = this.props;
    if (!this.rootRef.current.contains(e.target)) {
      setDragPopup({
        isShow: false,
      });
    }
  };

  render() {
    const { dragPopup } = this.props;
    if (!dragPopup.isShow) {
      return null;
    }
    return (
      <div className="drag-popup" onClick={this.onClick}>
        <div ref={this.rootRef} className="drag-popup-content">
          <div className="drag-popup-header text-center">
            {<Translate value={dragPopup.content} />}
          </div>
          <div className="drag-popup-body d-flex flex-column align-items-center">
            <div>
              <Translate value="common.labelPopupDragComponent" />
            </div>
            <div>
              <Translate value="common.pressEscToExit" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DragPopup.propTypes = {
  dragPopup: PropTypes.object.isRequired,
  setDragPopup: PropTypes.func.isRequired,
  listOrganizationByOrganCode: PropTypes.object.isRequired,
  changeCountPopout: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dragPopup: state[REDUCER_NAME].dragPopup,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listCoveredWarrantCode: state[COMMON_REDUCER_NAME].listCoveredWarrantCode,
    listDerivativeByDerivativeCode:
      state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
  };
};

const mapDispatchToProps = {
  setDragPopup,
  changeCountPopout,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DragPopup);
